function Shop(){
    return(
        <h1>Shop</h1>
    )
}
export default Shop;